<template>
  <div id="stockList">
    <ag-grid-vue
        height="500px"
      ref="agGridTable"
      class="ag-theme-material ag-grid-table"
      rowSelection="multiple"
      :gridOptions="gridOptions"
      :getRowHeight="getRowHeight"
      :defaultColDef="defaultColDef"
      :columnDefs="columnDefs"
      :floatingFilter="true"
      :rowData="productDataForAggrid"
      :isFullWidthCell="isFullWidthCell"
      :fullWidthCellRenderer="fullWidthCellRenderer"
      id="myGrid"
      :pagination="true"
      :paginationPageSize="40"
      :suppressPaginationPanel="true"
      @rowClicked="selectedRow"
    ></ag-grid-vue>
    <vs-pagination :total="totalPages" :max="maxPageNumbers" v-model="currentPage" />
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";


export default {
  components: {
    AgGridVue,
  },
  props: {
    productDataForAggrid: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      maxPageNumbers: 8,
      gridOptions: null,
      gridApi: null,
      columnApi: null,
      isFullWidthCell: null,
      fullWidthCellRenderer: null,
      getRowHeight: null,
      columnDefs: null,
      defaultColDef: null,
    };
  },
  beforeMount() {
    this.gridOptions = {};
    this.defaultColDef = {
      sortable: true,
      resizable: true,
      suppressMenu: true,
      editable: true,
      skipHeaderOnAutoSize: true,
    };
    (this.columnDefs = [
      {
        headerName: "Ürün",
        field: "productName",
        filter: true,
        width: 300,
        pinned: "left",
      },
      {
        headerName: "Stok",
        field: "stock",
        filter: "agNumberColumnFilter",
      },
    ]),
      (this.getRowHeight = (params) => {
        if (params.data.header) {
          return 60;
        } else return 40;
      });
  },
  computed: {
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
  },
  methods: {
    selectedRow(p) {
      this.$emit("selectedProduct", p.data);
    },
  },

  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
    this.gridApi.sizeColumnsToFit();
  },
};
</script>
<style lang="scss" scoped>
#stockList {
  .ag-grid-table{
    height: calc(100vh - 17rem);
  }
  th,
  td {
    font-size: 1rem !important;
  }

  .full-width-row {
    background-color: #bed2f0;
    border: 2px solid #3e8b99;
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    text-align: center;
    line-height: 1.3em;
    float: left;
    padding-top: 5px;
  }
}
</style>